var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3"},[_c('b-form-group',{attrs:{"label":"Options","label-cols-sm":"0","label-cols-md":"1","label-size":"sm","label-class":"text-muted"}},[_c('reorderable-list',{attrs:{"config":{ options:_vm.data.options }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }